/**
 * Side-effect module: import first from the app entry so module-scope `window` / `document` /
 * `navigator` use is safe. Tests/storybook should import this before other `@/` code when needed.
 */
if (
  typeof document === "undefined" ||
  typeof window === "undefined" ||
  typeof navigator === "undefined"
) {
  throw new Error(
    "This bundle requires document, window, and navigator (run in a browser or jsdom).",
  );
}
